import MessageBoxContextProvider from "pages/MessageBox/MessageBoxContext";
import MessageBoxContent from "pages/MessageBox/MessageBoxContent";
import "pages/MessageBox/MessageBox.scss";

function MessageBox() {
  return (
    <MessageBoxContextProvider>
      <MessageBoxContent/>
    </MessageBoxContextProvider>
  );
}

export default MessageBox;
